import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
  maxWidth: theme.spacing(60),
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
}));

export const Subtitle = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

export const Form = styled.form<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
  maxWidth: theme.spacing(60),
}));

export const Description = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

export const EmailHighlight = styled.span<Theme>(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.primary,
}));

export const CodeInputContainer = styled.div<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ErrorMessage = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.error.main,
  marginTop: theme.spacing(1),
}));

export const SubmitButtonContainer = styled.div<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(4, 0),
}));

export const ResendContainer = styled.div<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const Infos = styled.div<Theme>(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '16px',
  margin: theme.spacing(3, 0),
}));

export const Timer = styled.div<Theme>(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '16px',
  textAlign: 'center',
}));

export const ResendButton = styled.button<Theme>(({ theme }) => ({
  background: 'none',
  border: 'none',
  color: theme.colors.paletteFromBO.main,
  cursor: 'pointer',
  textDecoration: 'underline',
  fontSize: '14px',
  '&:disabled': {
    color: theme.palette.text.disabled,
    cursor: 'not-allowed',
    textDecoration: 'none',
  },
}));

export const AttemptsCounter = styled.span<Theme>(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
}));

export const BackToLoginContainer = styled.div<Theme>(({ theme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(3),
}));

export const BlockedAccountWarning = styled.div<Theme>(({ theme }) => ({
  backgroundColor: theme.colors.paletteFromBO.main,
  color: theme.colors.white,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  fontSize: '18px',
  fontWeight: 'bold',
  marginBottom: theme.spacing(4),
}));

export const ResendLimitWarning = styled.div<Theme>(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  textAlign: 'center',
  marginTop: theme.spacing(1),
  width: '100%',
}));

export const ResendSuccess = styled.div<Theme>(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  textAlign: 'center',
  marginTop: theme.spacing(1),
  width: '100%',
}));

export const ResendError = styled.div<Theme>(({ theme }) => ({
  color: theme.colors.error.main,
  fontSize: '14px',
  textAlign: 'center',
  marginTop: theme.spacing(1),
  width: '100%',
}));
